import React from 'react';
import {Trans} from '@lingui/react';
import PropTypes from 'prop-types';

import FlatButton from '../../FlatButton';
import ChevronRightIcon from '../../Icons/ChevronRightIcon';

import cls from 'classnames';
import s from './TopBar.css';

export default function TopBar(props) {
  const {currentPage, totalPage, pageLocked, onNext, onPrevious, evaluatedUserName} = props;

  return (
    <>
      <div className={s.TopBar}>
        <div className={s.OuterCircle}>
         
        </div>
      </div>

      <nav className={s.Navigation360}>
        <FlatButton className={s.FlatButton} onClick={onPrevious} disabled={currentPage < 2}>
          <ChevronRightIcon className={cls(s.Icon, s.IconPrevious)} />
          <span>
            <Trans id="topbar.previous_set">Set precedente</Trans>
          </span>
        </FlatButton>

        <FlatButton
          className={s.FlatButton}
          onClick={onNext}
          disabled={currentPage >= totalPage || pageLocked}
        >
          <span>
            <Trans id="topbar.next_set">Set successivo</Trans>
          </span>
          <ChevronRightIcon className={s.Icon} />
        </FlatButton>
      </nav>
    </>
  );
}

TopBar.propTypes = {
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
  pageLocked: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  evaluatedUserName: PropTypes.string,
};
